import { TranslateType } from '../types';
import useDependencyManagerContext from '../useDependencyManagerContext';

/**
 * Creates a simplified translation helper function
 * @param translate - The translate function from dependency manager context
 * @returns A helper function that takes a key and default value
 */
export const createTranslationHelper = (translate: TranslateType) => {
  return (key: string, defaultValue: string) => translate(key, defaultValue);
};

/**
 * Custom hook that provides a translation helper function
 * @returns A helper function that takes a key and default value
 */
export const useTranslationHelper = () => {
  const { translate } = useDependencyManagerContext();
  return (key: string, defaultValue: string) => translate(key, defaultValue);
};

/**
 * Type for the translation helper function
 */
export type TranslationHelperType = (
  key: string,
  defaultValue: string
) => string;
